module.exports = __webpack_public_path__ + "img/Koln.3b556ab8.png";